@if (subRegionsQueryResults$ | async; as result) {
<kendo-label text="SubRegion">
    <kendo-multiselect [data]="result.data ?? []"
                       [disabled]="isDisabled || result.isLoading"
                       [loading]="result.isLoading"
                       [placeholder]="result.isLoading ? 'Loading' : ''"
                       [virtual]="virtual"
                       [value]="value"
                       (valueChange)="handleValueChange($event)"
                       (blur)="handleBlur()"
                       [valuePrimitive]="true">
    </kendo-multiselect>
</kendo-label>
}
